<!-- <button mat-button (click)="generateEvent()">gen</button> -->
<mgl-map
  [style]="'mapbox://styles/notsosapien/clukaa9os00j701nt6dqxhk2x'"
  [zoom]="[1.3]"
  [center]="[-37, 5]"
  class="flex flex-grow flex-shrink w-full h-full"
>
</mgl-map>
